(() => {
  const root = document.querySelector('[data-interview]');
  if (!root) return;

  const imgEl = root.querySelector('[data-interview-image]');
  const blocks = Array.from(root.querySelectorAll('[data-interview-block]'));
  if (!imgEl || blocks.length === 0) return;

  // 初期画像：最初に画像を持つブロック
  const firstWithImage = blocks.find(b => b.dataset.imageUrl);
  if (firstWithImage) {
    imgEl.src = firstWithImage.dataset.imageUrl;
    imgEl.alt = firstWithImage.dataset.imageAlt || '';
  } else {
    // 画像が1枚も無いなら左カラムごと隠す
    const media = root.querySelector('.interview__media');
    if (media) media.style.display = 'none';
    return;
  }

  // 画像切り替え関数（同じURLなら更新しない）
  const setImageFromBlock = (block) => {
    const url = block.dataset.imageUrl;
    if (!url) return; // 画像が無いブロックはスルー（直前画像を維持）
    if (imgEl.getAttribute('src') === url) return;

    imgEl.src = url;
    imgEl.alt = block.dataset.imageAlt || '';
  };

  const observer = new IntersectionObserver((entries) => {
    // 画面内に入っている候補から「一番上に近いもの」を採用
    const visible = entries
      .filter(e => e.isIntersecting)
      .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);

    if (visible.length > 0) setImageFromBlock(visible[0].target);
  }, {
    root: null,
    // 右本文の“中腹”あたりで切り替わるように調整
    rootMargin: '-35% 0px -55% 0px',
    threshold: 0.01
  });

  blocks.forEach(b => observer.observe(b));
})();
